export default {
  clearAttendanceForm({ commit }) {
    commit('setAttendance', null)
    commit('setOriginalAttendance', null)
    commit('setCurrentStepIndex', 0)
    commit('setCurrentPhaseIndex', 0)
    commit('setSavingData', false)
    commit('setLocalSyncedData', true)
    commit('setServerSyncedData', true)
  },

  setAttendance({ commit }, attendance) {
    commit('setAttendance', attendance)
    commit('setOriginalAttendance', attendance)
  },

  setAttendanceValidation({ commit }, data) {
    commit('setAttendanceValidation', data)
    commit('setLocalSyncedData', false)
    commit('setServerSyncedData', false)
  },

  setPhaseData({ commit }, { key, data }) {
    commit('setPhaseData', { key, data })
    commit('setLocalSyncedData', false)
    commit('setServerSyncedData', false)
  },

  setAttendanceMode({ commit }, mode) {
    commit('setAttendanceMode', mode)
    commit('setLocalSyncedData', false)
    commit('setServerSyncedData', false)
  },

  setAttendanceVersion({ commit }, version) {
    commit('setAttendanceVersion', version)
    commit('setLocalSyncedData', false)
    commit('setServerSyncedData', false)
  },

  setAttendanceNote({ commit }, note) {
    commit('setAttendanceNote', note)
    commit('setLocalSyncedData', false)
    commit('setServerSyncedData', false)
  },

  setAttendanceMedicalReport({ commit }, report) {
    commit('setAttendanceMedicalReport', report)
    commit('setLocalSyncedData', false)
    commit('setServerSyncedData', false)
  },

  setAttendanceMedicalReportReferences({ commit }, references) {
    commit('setAttendanceMedicalReportReferences', references)
    commit('setLocalSyncedData', false)
    commit('setServerSyncedData', false)
  },

  setAttendanceHypothesis({ commit }, hypothesis) {
    commit('setAttendanceHypothesis', hypothesis)
    commit('setLocalSyncedData', false)
    commit('setServerSyncedData', false)
  },

  setAttendanceSummary({ commit }, summary) {
    commit('setAttendanceSummary', summary)
    commit('setLocalSyncedData', false)
    commit('setServerSyncedData', false)
  },

  startServerSyncing({ commit }) {
    commit('setSavingData', true)
    commit('setLocalSyncedData', true)
  },

  endServerSyncing({ commit, state }, success) {
    commit('setSavingData', false)
    commit('setServerSyncedData', state.isLocalSyncedData && success)
  },

  setPatientAcceptedTerms({ commit }, acceptedTerms) {
    commit('setPatientAcceptedTerms', acceptedTerms)
  },

  goToPhase({ commit, getters }, { step, phase }) {
    if (
      step < 0 ||
      phase < 0 ||
      step > getters.attendanceConfig.getLastStepIndex() ||
      phase > getters.attendanceConfig.getLastPhaseIndex(step)
    ) {
      return
    }
    commit('setCurrentStepIndex', step)
    commit('setCurrentPhaseIndex', phase)
  },

  nextPhase({ commit, getters, state }) {
    if (getters.isFinalPhase) {
      return
    }

    if (getters.isLastPhaseInStep) {
      commit('setCurrentStepIndex', state.currentStepIndex + 1)
      commit('setCurrentPhaseIndex', 0)
    } else {
      commit('setCurrentPhaseIndex', state.currentPhaseIndex + 1)
    }
  },

  prevPhase({ commit, getters, state }) {
    if (getters.isStartPhase) {
      return
    }

    if (getters.isFirstPhaseInStep) {
      const newStepIndex = state.currentStepIndex - 1
      commit('setCurrentStepIndex', newStepIndex)
      commit('setCurrentPhaseIndex', getters.attendanceConfig.getLastPhaseIndex(newStepIndex))
    } else {
      commit('setCurrentPhaseIndex', state.currentPhaseIndex - 1)
    }
  },
}
